import PropTypes from 'prop-types'
import React, { useMemo, useState } from 'react'
import { connect, shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { hasValue } from 'utils/NumberUtil'
import Card from '../../../components/card/Card'
import Input from '../../../components/forms/Input'
import DtoSandreCode from '../../../referencial/dto/DtoSandreCode'
import DtoDeclaration from '../../../survey/dto/DtoDeclaration'
import { round } from '../../../utils/NumberUtil'
import { formatMilliers } from '../../../utils/StringUtil'
import { push } from '@lagunovsky/redux-react-router'
import AgriAction from 'agriAdministration/actions/AgriAction'
import ExportFileModal from 'components/modal/ExportFileModal'
import { compact } from 'lodash'
import { CHRONICLES_CONSTANTS, SITU_POINT_PUMP, SITU_PUMP_COUNTER, SURVEY_TYPES } from 'agriAdministration/constants/AgriConstants'
import ToastrAction from 'toastr/actions/ToastrAction'
import { downloadURI } from 'utils/ExportDataUtil'
import Select from 'components/forms/Select'
import { Grid, Stack } from '@mui/material'
import moment from 'moment'
import { getCampaignPeriod, getCampaignYear } from 'utils/DateUtil'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'
import { groupBy } from 'lodash'
import { getDeclarationAdvancement } from '../../../utils/AgriUtils'

const DeclarationStatsCard = ({
    declaration,
    title,
    className,
    sandreCodes = [],
    key,
}) => {
    const [modalOpen, setModalOpen] = useState(false)
    const [modelSynthese, setModelSynthese] = useState()
    const [modelDeclaration, setModelDeclaration] = useState()
    const [modelNotification, setModelNotification] = useState()

    const {
        surveys,
        allModelsByType,
        exploitation,
        variousMateriels,
    } = useSelector(store => ({
        surveys: store.AgriReducer.surveys,
        allModelsByType: store.AdministrationReducer.allModelsByType,
        exploitation: store.AgriReducer.exploitation,
        variousMateriels: store.VariousMaterielReducer.variousMateriels,
    }), shallowEqual)

    const status = sandreCodes.find((c) => c.field === 'DECLARATIONS.STATUT' && c.code === declaration.statusCode) || {}
    const volumes = declaration.link_volumes.length ? declaration.link_volumes : []
    const allocatedVolumeFiltered = volumes.filter((v) => hasValue(v.attributedVolume)).map((v) => v.attributedVolume)
    const allocatedVolume = allocatedVolumeFiltered.length ? Math.round(allocatedVolumeFiltered.reduce((a, b) => a + b)) : null
    const authorizedVolumeFiltered = volumes.filter((v) => hasValue(v.authorizedVolume)).map((v) => v.authorizedVolume)
    const authorizedVolume = authorizedVolumeFiltered.length ? Math.round(authorizedVolumeFiltered.reduce((a, b) => a + b)) : null
    const advancement = getDeclarationAdvancement(declaration)

    const dispatch = useDispatch()
    const startDateCampaign = useApplicationSetting('startDateCampaign')

    const goToDeclaration = () => {
        dispatch(AgriAction.changeExploitationAdministrator(declaration.idExploitation)).then(() => {
            dispatch(push(`/survey/${declaration.idSurvey}/declaration/${declaration.idDeclaration}/stepper/0`))
        })
    }

    const createAndDownloadSynthesisEdition = (id) => {
        dispatch(ToastrAction.info(i18n.loadingDocument))
        dispatch(AgriAction.getSynthesisDeclaration(id, modelSynthese)).then((json) => downloadURI(json?.targetPath))
    }

    const createAndDownloadEdition = (id) => {
        dispatch(ToastrAction.info(i18n.loadingDocument))
        dispatch(AgriAction.getEditionDeclaration(id, modelDeclaration)).then((json) => downloadURI(json?.targetPath))
    }

    const getNotification = (idExploitation, year) => {
        dispatch(ToastrAction.info(i18n.loadingDocument))
        dispatch(AgriAction.getNotifEdition(idExploitation, year, modelNotification)).then((json) => downloadURI(json?.targetPath))
    }

    const modelsFormatted = useMemo(() => (
        allModelsByType.map((m) => ({
            ...m,
            nameFormatted: m.name.split('.')[0],
        }))
    ), [allModelsByType])

    const isAnnualSurvey = useMemo(() => surveys.find((s) => s.idSurvey === declaration.idSurvey).surveyType === SURVEY_TYPES.ANNUAL, [surveys, declaration])

    const getEstimConso = (groupedChronicles) => groupedChronicles.map((chroniques) => {
        return chroniques.filter((c) => c.measureType === CHRONICLES_CONSTANTS.TYPE_ESTIM &&
                getCampaignYear(moment(c.measureDate), startDateCampaign) === (isAnnualSurvey ? declaration.year - 1 : declaration.year))
            .reduce((acc, c) => acc + c.value, 0) || 0
    }).reduce((acc, c) => acc + c, 0)


    const getMateriels = (pointsIds, showShared = false) => {
        const pointsPumps = exploitation.link_materiel.filter((m) => m.siteType === SITU_POINT_PUMP && pointsIds.includes(m.siteCode)) || []
        const pointsCounters = exploitation.link_materiel.filter((m) => m.siteType === SITU_PUMP_COUNTER && pointsPumps.find(({ idVarious }) => idVarious === m.siteCode)) || []
        const pumpsIds = pointsPumps.map(({ idVarious }) => idVarious)
        const countersIds = pointsCounters.map(({ idVarious }) => idVarious)
        const materiels = variousMateriels.filter((m) => [...pumpsIds, ...countersIds].includes(m.id) && (!hasValue(m.administrator) || (m.administrator === exploitation.operatorCode) || (showShared && m.isShared)))
        return { pumpsIds, countersIds, materiels }
    }

    const { year, idExploitation, surveyName, nbPts,
        realVolume, prevVolume, eligibleTankVolume, idDeclaration } = declaration
    const yearReal = isAnnualSurvey ? year - 1 : year

    const exploitationPointsIds = useMemo(() => compact(exploitation.link_samplings
        .filter((p) => (!p.startDate || p.startDate <= getCampaignPeriod(yearReal, startDateCampaign).endDate) &&
					(!p.endDate || p.endDate >= getCampaignPeriod(yearReal, startDateCampaign).startDate)))
        .map(instal => instal.idInstallation)
    , [exploitation, yearReal, startDateCampaign])

    const { pumpsIds, countersIds } = getMateriels(exploitationPointsIds)
    const chroniclesMat = exploitation.link_chronicles.filter(({ idMat }) => [...pumpsIds, ...countersIds].includes(idMat))
    const pointsChronicles = chroniclesMat.filter(({ measureDate }) => getCampaignYear(moment(measureDate), startDateCampaign) === yearReal)

    const groupedByMat = Object.values(groupBy(pointsChronicles, 'idMat'))
    const estimConso = groupedByMat.length ? getEstimConso(groupedByMat) : null

    const exportNotif = isAnnualSurvey ? {
        name: i18n.notification,
        formats: [{
            type: 'pdf',
            callback: () => getNotification(idExploitation, year),
        }],
        settingsContent: (
            <Grid size={6}>
                <Select
                    label={i18n.model}
                    options={modelsFormatted.filter((m) => m.stationType === 'agriNotification')}
                    value={modelNotification}
                    onChange={(v) => setModelNotification(v)}
                    keyLabel='nameFormatted'
                    keyValue='name'
                    noNullValue
                    obligatory
                />
            </Grid>
        ),
    } : null

    return (
        <>
            <Card
                key={key}
                title={title || i18n.lastDeclaration}
                className={className}
                noMargin={false}
                actions={[{
                    onClick: () => goToDeclaration(),
                    iconName: 'description',
                    tooltip: i18n.consult,
                }, {
                    onClick: () => setModalOpen(true),
                    iconName: 'file_download',
                    tooltip: i18n.export,
                }]}
                round
            >
                <Stack sx={{ padding: 1 }}>
                    <Grid container size={12} justifyContent='space-between'>
                        <Input
                            title={i18n.survey}
                            value={surveyName}
                            readMode
                        />
                        <Input
                            title={i18n.type}
                            value={isAnnualSurvey ? i18n.yearly : i18n.intermediate}
                            readMode
                        />
                    </Grid>
                    <Grid container size={12} justifyContent='space-between'>
                        <Input
                            title={i18n.status}
                            value={status.name}
                            readMode
                        />
                        <Input
                            title={i18n.progression}
                            value={`${advancement}%`}
                            readMode
                        />
                    </Grid>
                    <Input
                        title={i18n.nbPtsDeclared}
                        value={nbPts}
                        readMode
                    />
                    <Input
                        title={i18n.countedConsumption}
                        value={`${formatMilliers(realVolume) || 0} m3`}
                        readMode
                    />
                    <Input
                        title={i18n.estimConsumption}
                        value={`${formatMilliers(estimConso) || 0} m3`}
                        readMode
                    />
                    <Input
                        title={i18n.requestedVolume}
                        value={`${formatMilliers(prevVolume) || 0} m3`}
                        readMode
                    />
                    <Input
                        title={i18n.detentionsEligibles}
                        value={hasValue(eligibleTankVolume) ? `${formatMilliers(round(eligibleTankVolume, 0))} m3` : i18n.unknown}
                        readMode
                    />
                    <Input
                        title={i18n.allocatedVolume}
                        value={hasValue(allocatedVolume) ? `${formatMilliers(allocatedVolume)} m3` : i18n.unknown}
                        readMode
                    />
                    <Input
                        title={i18n.authorizedVolume}
                        value={hasValue(authorizedVolume) ? `${formatMilliers(authorizedVolume)} m3` : i18n.unknown}
                        readMode
                    />
                </Stack>
            </Card>
            {modalOpen && (
                <ExportFileModal
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    data={compact([{
                        name: i18n.synthesis,
                        formats: [{
                            type: 'pdf',
                            callback: () => createAndDownloadSynthesisEdition(idDeclaration),
                        }],
                        settingsContent: (
                            <Grid size={6}>
                                <Select
                                    label={i18n.model}
                                    options={modelsFormatted.filter((m) => m.stationType === 'agriSynthese')}
                                    value={modelSynthese}
                                    onChange={(v) => setModelSynthese(v)}
                                    keyLabel='nameFormatted'
                                    keyValue='name'
                                    noNullValue
                                    obligatory
                                />
                            </Grid>
                        ),
                    }, {
                        name: i18n.exportEmpty,
                        formats: [{
                            type: 'pdf',
                            callback: () => createAndDownloadEdition(idDeclaration),
                        }],
                        settingsContent: (
                            <Grid size={6}>
                                <Select
                                    label={i18n.model}
                                    options={modelsFormatted.filter((m) => m.stationType === 'agriDeclaration')}
                                    value={modelDeclaration}
                                    onChange={(v) => setModelDeclaration(v)}
                                    keyLabel='nameFormatted'
                                    keyValue='name'
                                    noNullValue
                                    obligatory
                                />
                            </Grid>
                        ),
                    }, exportNotif])}
                />
            )}
        </>
    )
}

DeclarationStatsCard.propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
    key: PropTypes.number,
    actions: PropTypes.arrayOf(PropTypes.shape({
        onClick: PropTypes.func,
        iconName: PropTypes.string,
    })),
    declaration: PropTypes.instanceOf(DtoDeclaration).isRequired,
    sandreCodes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSandreCode)),
}

const mapStateToProps = (store) => {
    return {
        sandreCodes: store.ReferencialReducer.sandreCodes,
    }
}

export default connect(mapStateToProps)(DeclarationStatsCard)
